import { type CSSProperties } from 'react'
import { Avatar, type IAvatarInfo, Typography, Box, type IIconProps } from 'shared/ui'
import { EmptyCell } from 'shared/ui/Table'

export const getCellForNameDefault = ({
  avatarInfo,
  fullName,
  width = '100%',
  size = 24,
  value,
  fontSize,
  iconProps,
}: {
  avatarInfo: IAvatarInfo
  fullName?: string
  width?: CSSProperties['width']
  size?: number
  value?: string
  fontSize?: number
  iconProps?: IIconProps
}) => {
  return (
    <Box display='flex' justifyContent='space-between' minWidth={0}>
      <Box
        sx={{
          alignItems: 'center',
          width,
          minWidth: 0,
          height: '32px',
        }}
        gap={1}
        display='flex'
      >
        <Avatar info={avatarInfo} size={size} fontSize={fontSize} iconProps={iconProps} />

        {fullName ? (
          <Typography
            ellipsis
            variant={'body-md-regular'}
            tag={'div'}
            ariaLabel={'formattedValue'}
            tooltipProps={{
              label: fullName,
              breakWord: true,
            }}
          >
            {fullName}
          </Typography>
        ) : (
          <EmptyCell />
        )}
        {!!fullName && !!value && <div className='point' />}
        {value && (
          <Typography variant='body-md-regular' color='tertiary' ariaLabel='value'>
            {value}
          </Typography>
        )}
      </Box>
    </Box>
  )
}
